export const blockIconsContentInsights = (
	<span className='material-symbols-outlined'>insights</span>
);
